import { isCNH } from 'validation-br';
import { StringSchema } from 'yup';

export default function (this: StringSchema, message = 'Digite uma CNH válida.') {
  return this.test('cnh', message, (value = '') => {
    if (value.includes('*')) return true;
    return isCNH(value);
  });
}
